<template>
    <div class="search-bar">
        <div class="label">
            {{label}}：
        </div>

        <div class="list-body" :class="{'not-auto-expand': showMore, expand: expandController}">
            <div class="list" ref="list">
                <div v-if="!isNotShowAll" class="all item" :class="{active: (!selected || !selected.length),}" @click="handlerAllClick">
                    全部
                </div>

                <div class="item" :class="{active: item.isSelected}" v-for="(item, index) in usingData" :key="index" @click="clickHandler(item,index)">
                    {{item[props.label]}}
                </div>
            </div>

        </div>

        <div v-if="showMoreController" class="show-more">
            <div v-if="!expandController" class="btn" @click="shiftExpandHandler">
                <i class="el-icon-arrow-down"></i>
                更多
            </div>
            <div v-if="expandController" class="btn" @click="shiftExpandHandler">
                <i class="el-icon-arrow-up"></i>
                折叠
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number],
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        props: {
            type: Object,
            default: () => ({
                label: 'dicname',
                value: 'diccode',
            }),
        },
        action: {
            type: String,
            default: '',
        },
        all: {
            type: Boolean,
            default: true,
        },
        afterClick: {
            type: Function,
            default: function () {},
        },
        '2way': {
            type: String,
        },
        // 默认选中值
        defActive: {
            type: String,
            default: '',
        },

        // 仅单选
        isNotShowAll: {
            type: Boolean,
            default: false,
        },
        keyName: {
            type: String,
            default: '',
        },
        // 使用更多按钮
        showMore: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            innerData: [],
            showMoreController: false,
            expandController: false,
        };
    },
    watch: {
        selected: {
            handler(val) {
                let target = val.map((item) => item[this.keyName]);

                // if (target && target.length == 0) {
                //     //全部
                //     this.model = this.usingData
                //         .map((item) => {
                //             return item[this.keyName];
                //         })
                //         .join();
                // } else {
                    this.model = target.join();
                // }

            },
            deep: true,
        },
        defActive: {
            handler() {
                setTimeout(() => {
                    this.setDefaultSel();
                }, 500);
            },
            deep: true,
            immediate: true,
        },
        // usingData: {
        //     handler() {
        //         this.$nextTick(() => {
        //             this.checkShowMoreBtn();
        //         });
        //     },
        //     immediate: true,
        // },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        usingData() {
            this.$nextTick(() => {
                this.checkShowMoreBtn();
            });

            if (this.action) {
                return this.innerData;
            } else {
                return this.data;
            }
        },
        selected() {
            if (!this.usingData || !this.usingData.length) {
                return [];
            }

            return this.usingData.filter((item) => item.isSelected);
        },
    },
    methods: {
        //全部，传的是所有的code。
        handlerAllClick() {
            this.reset();

            this.$emit('click', null, 0);
        },
        reset() {
            this.usingData.forEach((item) => {
                this.$set(item, 'isSelected', false);
            });
        },
        // resetSelected() {
        //     this.usingData.forEach((item) => {
        //         this.$set(item, 'isSelected', true);
        //     });
        // },

        clickHandler(item, index) {
            // this.model = item[this.props.value];

            // item.isSelected = !item.isSelected;
            this.$set(item, 'isSelected', !item.isSelected);

            !!this.afterClick && this.afterClick(item, index);

            if (this['2way']) {
                var modelArr = this['2way'].split(',');
                if (this.multiple) {
                    modelArr.forEach(
                        function (key) {
                            var updateData = item.reduce(function (arr, i) {
                                arr.push(that.usingData[i][key]);
                                return arr;
                            }, []);

                            if (that.modelStr) {
                                updateData = updateData.join(that.strSpliter);
                            }

                            that.$emit('update:' + key, updateData);
                        }.bind(this)
                    );
                } else {
                    modelArr.forEach(
                        function (key) {
                            this.$emit('update:' + key, (this.options[item] || {})[key]);
                        }.bind(this)
                    );
                }
            }
        },
        queryData() {
            if (!this.action) return;

            this.$get(this.action, (data) => {
                if (this.all) {
                    data.unshift({
                        [this.props.label]: '全部',
                        [this.props.value]: '',
                    });
                }

                this.innerData = data;
            });
        },

        dataHandler() {
            this.data.forEach((item) => {
                item.isSelected = false;
            });
        },

        //设置默认值
        setDefaultSel() {
            if (!this.defActive) {
                return;
            }

            var defIndex = this.usingData.findIndex((item) => {
                return item[this.props.label] === this.defActive;
            });

            if (!~defIndex) {
                return;
            }

            this.reset();
            this.$set(this.usingData[defIndex], 'isSelected', true);
        },

        // 检查是否需要展示更多按钮
        checkShowMoreBtn() {
            if (!this.showMore) {
                return;
            }

            var list = this.$refs.list;
            if (!list) {
                return;
            }

            this.showMoreController = list.clientHeight > 26;
        },

        // 切换展开状态
        shiftExpandHandler() {
            this.expandController = !this.expandController;
        },
    },
    mounted() {
        this.queryData();
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.search-bar {
    overflow: hidden;
    color: #333;
    line-height: 1em;
    padding: 20px 0;

    // & + .search-bar {
    & {
        border-top: 1px dashed #f0f0f0;
    }

    .label {
        float: left;
        margin-right: -6em;
        font-weight: bold;
    }
    .list-body {
        flex: 1;

        &.not-auto-expand {
            height: 26px;
            overflow: hidden;
            transition: all 0.3s;

            &.expand {
                height: auto;
            }
        }
    }

    .show-more {
        // padding: 6px 0;
        font-size: 12px;
        margin-bottom: -10px;

        .btn {
            cursor: pointer;
            line-height: 1em;
        }
    }

    .list {
        overflow: hidden;
        margin: -8px 0;
        margin-left: 6em;
        float: left;

        .item {
            float: left;
            margin: 8px 24px 8px 0;
            cursor: pointer;

            &:hover {
                color: $primaryColor;
            }

            &.active {
                color: $primaryColor;
                font-weight: bold;
            }
        }
    }
}
</style>